import { FontAwesomeIcons, PrimeReactIcons } from "./icons";
import IconCard from "./IconCard";
import { IconType } from "./types";

export type IconCardsProps = {
  iconType?: IconType;
  icon?: string;
  onChange: (iconType: IconType, icon?: string) => void;
};

const IconCards: React.FC<IconCardsProps> = (props) => {
  let icons;
  switch (props.iconType) {
    case IconType.PrimeIcon:
      icons = PrimeReactIcons.sort().map((iconDef: string) => (
        <IconCard
          key={iconDef}
          iconName={iconDef}
          onClick={() => props.onChange(IconType.PrimeIcon, iconDef)}
          selected={iconDef === props.icon}
        />
      ));
      break;
    case IconType.FontAwesome:
      icons = FontAwesomeIcons.map(({ iconName }) => (
        <IconCard
          key={iconName}
          iconName={iconName}
          onClick={() => props.onChange(IconType.FontAwesome, iconName)}
          selected={iconName === props.icon}
        />
      ));
      break;
    default:
      icons = <span>Kein Icon.</span>;
      break;
  }

  return <>{icons}</>;
};

export default IconCards;
